import { DataType, EditingMode, PagingPosition, SortingMode } from 'ka-table/enums';
import 'ka-table/style.css';
import React, { useEffect, useState } from 'react';
import { Table, useTable } from 'ka-table';
import { useApi } from '../../Api/useApi';
import { Box, Menu, MenuItem } from '@mui/material';
import { useParams } from 'react-router';
import { ElementInfo } from '../Models/ElementInfoModel';
import { GetPropertiesForProjectModelsResponse, ModelRycApiClient } from '../../Api/ApiServer';

export interface IPropertiesDataGridProps {
    onSelected: (ids: ElementInfo[]) => void;
    onIsolate: (ids: ElementInfo[]) => void;
    onHide: (ids: ElementInfo[]) => void;
    authorized: boolean;
    // modelId: number;
}

export default function PropertiesDataGrid(props: IPropertiesDataGridProps) {
    const { authorizedApi, unauthorizedApi } = useApi(ModelRycApiClient);
    const params = useParams();
    const [columns, setColumns] = useState<any[]>([]);
    const [elements, setElements] = useState<any[]>([]);
    const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number; rowId: number | null } | null>(null);
    const getModelIdsFromRoute = () => {
        if (params['id'] && params.id.indexOf(('&')) !== -1) {
            const ids = params.id.split('&');
            return ids.map(Number);
        }
        else if (params['id']) {
            return [Number(params.id)];
        }
        else return [];
    }
    const parseData = (data: GetPropertiesForProjectModelsResponse) => {
        const columns: any[] = [];
        const elementsData: any[] = [];
        // results.elements?.forEach((data) => {
        if (!data) return;
        if (data.columns) {
            data.columns.forEach((column) => {
                if (!columns.some(existingColumn => existingColumn.key === column)) {
                    columns.push({
                        key: column,
                        title: column,
                        dataType: DataType.String,
                        width: 300
                    });
                }
            });
        }
        if (data.elements)
            elementsData.push(...data.elements);
        // });
        setColumns(columns);
        setElements(elementsData);
        console.log('Columns:', columns);
        console.log('Elements:', elementsData);
    }

    useEffect(() => {

        if (props.authorized) {
            authorizedApi?.getProjectModelsProperties(Number(params.id)).then((data) => {
                parseData(data);
            });
        }
        else {
            unauthorizedApi?.getProjectModelsPropertiesClient(params.code!).then((data) => {
                parseData(data);
            });
        }



    }, [authorizedApi, params.id, props.authorized, unauthorizedApi, params.code]);

    const [selection, setSelection] = useState<number | null>(null);
    useEffect(() => {
        console.log('Selection:', selection);
    }, [selection]);

    const table = useTable({
        onDispatch: (action, tableProps) => {
            if (action.type === 'SelectSingleRow') {
                setSelection(action.rowKeyValue);
            }
            if (action.type === 'DeselectAllRows') {
                setSelection(null);
            }
        },
    });

    const handleContextMenu = (event: React.MouseEvent, rowId: number) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4, rowId }
                : null,
        );
    };

    const handleClose = () => {
        setContextMenu(null);
    };

    const handleMenuItemClick = (hide: boolean) => {
        // console.log(`Action: ${action}, Row ID: ${contextMenu?.rowId}`);
        if (contextMenu !== null && contextMenu.rowId !== null) {
            const element = elements.find(e => e.ExpressId === contextMenu.rowId);
            if (hide) props.onHide([{ expressId: element.ExpressId, modelId: element.ModelId }]);
            else props.onIsolate([{ expressId: element.ExpressId, modelId: element.ModelId }]);
        }
        handleClose();
    };

    return (
        <Box>
            {
                columns.length > 0 && <Table
                    height={400}
                    table={table}
                    width={'100vw'}
                    columns={columns}
                    groupPanel={{
                        enabled: true,
                        text: 'Pro seskupení přetáhněte hlavičku sloupce na toto místo...'
                    }}
                    childComponents={{
                        dataRow: {
                            elementAttributes: (propse) => ({
                                onClick: (event, extendedEvent) => {
                                    console.log('Row clicked:', [{ modelId: extendedEvent.childProps.rowData.ModelId, expressId: extendedEvent.childProps.rowData.ExpressId }]);
                                    props.onSelected([{ modelId: extendedEvent.childProps.rowData.ModelId, expressId: extendedEvent.childProps.rowData.ExpressId }]);
                                    table.selectSingleRow(extendedEvent.childProps.rowData.ExpressId);
                                },
                                onContextMenu: (event) => handleContextMenu(event, propse.rowData.ExpressId),
                                contextMenu: "contextMenu"
                            }),
                        },
                    }}
                    paging={{
                        enabled: true,
                        pageIndex: 0,
                        pageSize: 50,
                        pageSizes: [50, 100, 200],
                        position: PagingPosition.Bottom
                    }}
                    selectedRows={[selection]}
                    data={elements}
                    editingMode={EditingMode.None}
                    rowKeyField={'id'}
                    sortingMode={SortingMode.Single}
                />
            }
            <Menu
                open={contextMenu !== null}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }
            >
                <MenuItem onClick={() => handleMenuItemClick(true)}>Skrýt</MenuItem>
                <MenuItem onClick={() => handleMenuItemClick(false)}>Izolovat</MenuItem>
            </Menu>
        </Box>
    );
}